<template>
  <div class="product-detail-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">网站首页</el-breadcrumb-item>
        <el-breadcrumb-item>产品业务</el-breadcrumb-item>
        <el-breadcrumb-item>{{ product.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 产品内容主体区域 -->
    <div class="product-content">
      <h1 class="product-title">{{ product.name }}</h1>

      <div class="product-section">
        <h2 class="section-title">产品定义</h2>
        <p class="section-content">
          {{ product.description }}
        </p>
      </div>

      <div class="product-info-grid">
        <div class="info-item">
          <div class="info-label">贷款金额</div>
          <div class="info-value">最高{{ product.maxAmount }}万元</div>
        </div>
        <div class="info-item">
          <div class="info-label">贷款期限</div>
          <div class="info-value">最长{{ product.maxTerm }}年</div>
        </div>
        <!-- <div class="info-item">
          <div class="info-label">贷款利率</div>
          <div class="info-value">8.25%~11.91%</div>
        </div> -->
      </div>

      <div class="product-section">
        <h2 class="section-title">特色</h2>
        <ul class="section-list">
          <li>{{ product.features }}</li>
        </ul>
      </div>

      <div class="product-section">
        <h2 class="section-title">适用对象</h2>
        <ul class="section-list">
          <li>
            {{ product.targets }}
          </li>
        </ul>
      </div>

      <div class="action-buttons">
        <el-button type="primary" size="large" @click="handleApply"
          >立即申请</el-button
        >
      </div>
      <div class="product-tips">
        <h3><i class="el-icon-info"></i> 温馨提示</h3>
        <p>1. 以上贷款利率、期限、金额仅供参考，具体以实际审批为准</p>
        <p>2. 本行保留对贷款的最终解释权</p>
        <p>3. 如有疑问，请咨询我行各营业网点或致电客服热线</p>
      </div>
    </div>
  </div>
</template>

<script>
// 导入API接口函数
import { getInfo } from "@/api";
export default {
  name: "ProductDetail", // 组件名称
  data() {
    return {
      id: "", // 产品ID
      product: {}, // 产品详情数据对象
    };
  },
  methods: {
    // 处理申请按钮点击事件
    handleApply() {
      // 跳转到申请页面，并传递产品ID
      this.$router.push("/apply/" + this.id);
    },
    // 获取产品详情数据
    getProducet() {
      // 调用API获取产品数据
      getInfo({
        model: "product", // 模型名称
        condition: {
          _id: this.id, // 根据ID查询
        },
      }).then((res) => {
        if (res.status == 200) {
          this.product = res.data.data[0]; // 设置产品详情数据
        }
      });
    },
  },
  // 组件创建时执行
  created() {
    const id = this.$route.params.id; // 从路由参数获取产品ID
    this.id = id; // 设置产品ID
    this.getProducet(); // 获取产品详情数据
  },
};
</script>

<style scoped>
.product-detail-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.breadcrumb {
  margin-bottom: 30px;
}

.product-content {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.product-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
  position: relative;
}

.product-title:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: #21ab4b;
}

.product-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 15px;
  position: relative;
  padding-left: 15px;
}

.section-title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background: #21ab4b;
}

.section-content {
  color: #666;
  line-height: 1.8;
  font-size: 16px;
}

.product-info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 30px 0;
}

.info-item {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.info-label {
  color: #666;
  margin-bottom: 10px;
  font-size: 16px;
}

.info-value {
  color: #21ab4b;
  font-size: 20px;
  font-weight: bold;
}

.section-list {
  list-style: none;
  padding: 0;
}

.section-list li {
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
  color: #666;
  font-size: 16px;
  line-height: 1.6;
}

.section-list li:before {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #21ab4b;
}

.action-buttons {
  text-align: center;
  margin: 40px 0;
}

.action-buttons .el-button {
  margin: 0 15px;
  padding: 12px 40px;
}

.action-buttons .el-button--primary {
  background: #21ab4b;
  border-color: #21ab4b;
}

.action-buttons .el-button--primary:hover {
  background: #24bb51;
  border-color: #24bb51;
}

.product-tips {
  background: #fff9f9;
  padding: 20px;
  border-radius: 8px;
  margin-top: 30px;
}

.product-tips h3 {
  color: #21ab4b;
  font-size: 18px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.product-tips h3 i {
  margin-right: 8px;
}

.product-tips p {
  color: #666;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.6;
}
</style>